import React from 'react';

import type IconBuilder from '~/components/patterns/icons/builders/iconsData/IconBuilder';



const BotIconBuilder: IconBuilder = {
	icon: ({ color = '#5C6773' }) => {
		return (
			<g
				fill="none"
				fillRule="evenodd"
				id="Page-1"
				opacity="0.7"
				stroke="none"
				strokeWidth="0.5"
			>
				<path
					d="M6.99821 4.14963V5.92134M3.23009 5.92134H10.7699V10.9586H3.23009V5.92134ZM6.26889 8.3392C6.26889 8.73636 5.93757 9.05831 5.52886 9.05831C5.12014 9.05831 4.78882 8.73636 4.78882 8.3392C4.78882 7.94205 5.12014 7.6201 5.52886 7.6201C5.93757 7.6201 6.26889 7.94205 6.26889 8.3392ZM7.57022 3.59728C7.57022 3.90425 7.31412 4.15311 6.99821 4.15311C6.6823 4.15311 6.4262 3.90425 6.4262 3.59728C6.4262 3.2903 6.6823 3.04145 6.99821 3.04145C7.31412 3.04145 7.57022 3.2903 7.57022 3.59728ZM9.21117 8.3392C9.21117 8.73636 8.87985 9.05831 8.47114 9.05831C8.06242 9.05831 7.7311 8.73636 7.7311 8.3392C7.7311 7.94205 8.06242 7.6201 8.47114 7.6201C8.87985 7.6201 9.21117 7.94205 9.21117 8.3392Z"
					stroke={color}
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth="0.7"
				/>
				<path
					d="M10.9651 7.93587H11.3738C11.8708 7.93587 12.2738 8.33881 12.2738 8.83587V10.9586"
					stroke={color}
					strokeLinecap="round"
					strokeWidth="0.6"
				/>
				<path
					d="M3.03508 7.93587H2.62644C2.12938 7.93587 1.72644 8.33881 1.72644 8.83587V10.9586"
					stroke={color}
					strokeLinecap="round"
					strokeWidth="0.6"
				/>

			</g>
		);
	},
	viewBoxHeight: 14,
	viewBoxWidth: 14,
};



export default BotIconBuilder;

